/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { SkillTag } from '@coursera/grpc-types-skills/coursera/proto/skills/tags/v2/skill_tag';

import EnterpriseLearningPathBreadcrumbsModuleRenderer from 'bundles/enterprise-learning-path-description-page/module-renderer/EnterpriseLearningPathBreadcrumbsModuleRenderer';
import EnterpriseSkillPathwayProductOverviewModuleRenderer from 'bundles/enterprise-learning-path-description-page/module-renderer/EnterpriseSkillPathwayProductOverviewModuleRenderer';
import EnterpriseSkillPathwaySyllabusModuleRenderer from 'bundles/enterprise-learning-path-description-page/module-renderer/EnterpriseSkillPathwaySyllabusModuleRenderer';
import type { EnterpriseLearningPathPageFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageQuery';
import { ModuleNames, type PageConfig } from 'bundles/unified-description-page-common/types/moduleConfig';

const styles = {
  container: css`
    padding-bottom: 36px;
  `,
};

type Props = {
  pageData: EnterpriseLearningPathPageFieldsFragment;
  skillTagsData: Record<string, SkillTag[]>;
  pageConfig?: PageConfig | null;
  vspPageData?: any;
};

const Renderer = ({ pageData, skillTagsData, pageConfig, vspPageData }: Props) => {
  if (!pageConfig || !pageConfig.modules.length || !skillTagsData) {
    return null;
  }

  const modulesToRender = pageConfig.modules.map((moduleConfig) => {
    switch (moduleConfig.name) {
      case ModuleNames.ProductOverview:
        return <EnterpriseSkillPathwayProductOverviewModuleRenderer pageData={pageData} vspPageData={vspPageData} />;
      case ModuleNames.Breadcrumbs:
        return (
          <EnterpriseLearningPathBreadcrumbsModuleRenderer
            productTitle={pageData?.enterpriseBadge?.name}
            pageData={pageData}
          />
        );
      case ModuleNames.Syllabus:
        return <EnterpriseSkillPathwaySyllabusModuleRenderer pageData={pageData} vspPageData={vspPageData} />;
      default:
        return null;
    }
  });
  return <div css={styles.container}>{modulesToRender}</div>;
};

export default Renderer;
